export default {
    // 正式
    "API_HOST": "http://wechat.bw30hl.com", //"http://192.168.12.83:18080", 正式：http://wechat.lanmaomobile.com  测试：http://localhost:18080
    // 测试
    // "API_HOST": "http://192.168.5.40:18080",
    // "API_HOST": " http://b2e52b.natappfree.cc", //"wxltest.lanmaomobile.com", 正式：http://wechat.lanmaomobile.com  测试：http://localhost:18080
    "APPID": "wx8ccbf1b823b9c62b",
    //显示loading框的接口列表
    "SHOW_LOADING_REQUEST_LIST": ['ADD_ORDERS', 'PAY', 'OPEN_FLOW', 'RESULT_QUERY', 'QUERY_PHONE', 'FACE_AUTH_ACCOUNT_BIND']
}